// AWS SDK v3's SigV4 signer (used by Amplify for IAM-authorized API calls) references
// the Node `Buffer` global directly; the browser has no such global, so polyfill it here
// before anything else runs.
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;

import 'bootstrap/dist/css/bootstrap.min.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// date-fns
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// or for dayjs
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// // or for luxon
// import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
// // or for moment
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// import "./index.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { initRum } from './rum';
import { RumPageViewTracker } from './rum-page-view-tracker';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
    },
  },
  API: {
    REST: {
      applications: {
        service: 'applications',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      commercialApplications: {
        service: 'commercial-applications',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      dealers: {
        service: 'dealers',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      payments: {
        service: 'payments',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      'dealer-documents': {
        service: 'dealer-documents',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      dealerProspects: {
        service: 'dealer-prospects',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      'admin-docs': {
        service: 'admin-docs',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      files: {
        service: 'files',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      documents: {
        service: 'documents',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      news: {
        service: 'news',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      users: {
        service: 'users',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      quotes: {
        service: 'quotes',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      contracting: {
        service: 'contracting',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    },
  },
});

initRum();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <GoogleReCaptchaProvider
        reCaptchaKey={config.app.recaptcha_sitekey}
        scriptProps={
          {
            // async: true, // optional, default to false,
            // defer: true, // optional, default to false
            // appendTo: "head", // optional, default to "head", can be "head" or "body",
            // nonce: undefined, // optional, default undefined
          }
        }
      >
        <Router>
          <RumPageViewTracker />
          <App />
        </Router>
      </GoogleReCaptchaProvider>
    </LocalizationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
